import { render, staticRenderFns } from "./NbIconConfirm.vue?vue&type=template&id=01eca453"
import script from "./NbIconConfirm.vue?vue&type=script&lang=js"
export * from "./NbIconConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports